import React from 'react';
import { carouselRoot, combineCarouselClasses } from './carousel.styles';
import type { CarouselRootProps } from './types';

/**
 * CarouselRoot - Root container for compound carousel API
 *
 * Provides the base container for carousel components when using the compound API.
 * This allows for more flexible composition with separate header, track, and control components.
 *
 * @example
 * ```tsx
 * <Carousel.Root>
 *   <Carousel.Header>
 *     <Carousel.Title>My Carousel</Carousel.Title>
 *     <Carousel.Controls />
 *   </Carousel.Header>
 *   <Carousel.Track>
 *     <Carousel.Item>Content</Carousel.Item>
 *   </Carousel.Track>
 * </Carousel.Root>
 * ```
 */
export const CarouselRoot = React.forwardRef<HTMLDivElement, CarouselRootProps>(
  ({ children, className, ...restProps }, ref) => {
    const combinedClassName = combineCarouselClasses(carouselRoot, className);

    return (
      <div ref={ref} className={combinedClassName} {...restProps}>
        {children}
      </div>
    );
  },
);

CarouselRoot.displayName = 'CarouselRoot';
